import React from 'react'
import type { FC } from 'react'
interface Props {
  className?: string;
  color?: string;
  size?: number | string;
  rotateOnRtl?: boolean;
}
export const IconArrowDownGraph: FC<Props> = ({
  color = 'currentColor',
  size = 24,
  className,
  rotateOnRtl = false,
  ...rest
}) => {
  const props = {
    width: size,
    height: size,
    fill: color,
    // stroke: color,
    className,
    viewBox: '0 0 24 24',
    ['data-rotateonrtl']: false,
    ...rest,
  }
  return /*#__PURE__*/ React.createElement(
    'svg',
    Object.assign(
      {
        width: 24,
        height: 24,
        viewBox: '0 0 24 24',
        xmlns: 'http://www.w3.org/2000/svg',
      },
      props
    ),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M0.293109 4.29268C0.683753 3.90227 1.31692 3.90247 1.70732 4.29311L8.64 11.23L11.0453 8.8233C11.8265 8.0416 13.0936 8.04169 13.8747 8.8235L21 15.9552V13.5793C21 13.027 21.4477 12.5793 22 12.5793C22.5523 12.5793 23 13.027 23 13.5793V17.8679C23 18.6963 22.3285 19.3679 21.5 19.3679H17.2114C16.6591 19.3679 16.2114 18.9201 16.2114 18.3679C16.2114 17.8156 16.6591 17.3679 17.2114 17.3679H19.5843L12.4599 10.2371L10.0546 12.6438C9.2735 13.4254 8.0065 13.4254 7.22535 12.6438L0.292677 5.70689C-0.0977278 5.31625 -0.0975343 4.68308 0.293109 4.29268Z',
    })
  )
}
